module.exports = __webpack_public_path__ + "img/ez-slot-category-casino.d0a7a7ed.png";